import moment from 'moment-timezone';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import defaultTimezone from 'constants/DefaultTimezone';
import { RootState } from 'store/rootState';

type PoolDateInput = string | Date | number | null | undefined;
function parseUtcMoment(value: PoolDateInput) {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsed = typeof value === 'number'
      ? moment.unix(value).utc()
      : moment.utc(value, moment.ISO_8601, true);

  return parsed.isValid() ? parsed : null;
}

const usePoolTimezone = () => {
  const timezone = useSelector(
    (state: RootState) =>
      state.pool?.location?.timezone_info || defaultTimezone,
  );

  const formatDate = useCallback(
    (value: PoolDateInput, format = 'DD-MM-YYYY HH:mm') => {
      const parsed = parseUtcMoment(value);
      if (!parsed) return null;

      return parsed.tz(timezone).format(format);
    },
    [timezone],
  );

  return { timezone, formatDate };
};

export default usePoolTimezone;
